//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiClose } from '@mdi/js'
import { ref } from '@vue/composition-api'

export default {
  model: {
    prop: 'isAddPaymentSidebarActive',
    event: 'update:is-add-payment-sidebar-active',
  },
  props: {
    isAddPaymentSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const date = new Date().toISOString().substr(0, 10)
    const addPaymentData = ref({
      balance: 5000,
      amount: null,
      paymentDate: new Date().toISOString().substr(0, 10),
      selectedPaymentMethod: '',
      paymentNote: '',

      // ? Need to handle how you want to send item
      // * You can also send link to download invoice in message
    })
    const paymentOptions = ['Cash', 'Bank Transfer', 'Debit', 'Credit', 'Paypal']

    return {
      date,
      addPaymentData,
      paymentOptions,
      icons: {
        mdiClose,
      },
    }
  },
}
